import React, { useState } from 'react';

export function useQuantity(
  initialQuantity: string,
): [quantityItems: string, setQuantityItems: React.Dispatch<React.SetStateAction<string>>] {
  const [quantityItems, setQuantityItems] = useState(initialQuantity);

  return [quantityItems, setQuantityItems];
}
